import { render, staticRenderFns } from "./MarkSheetArchiveSheetRecord.vue?vue&type=template&id=5e4e3460&scoped=true"
import script from "./MarkSheetArchiveSheetRecord.vue?vue&type=script&lang=js"
export * from "./MarkSheetArchiveSheetRecord.vue?vue&type=script&lang=js"
import style0 from "./MarkSheetArchiveSheetRecord.vue?vue&type=style&index=0&id=5e4e3460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e3460",
  null
  
)

export default component.exports